import axios from "axios";
import { ANALYTICS_LOG_API } from "src/config-global";
import {
  LogApiRequestParams,
  VisitLogApiParams,
  PlayLogApiParams,
  NextActionLogApiParams,
  CopyLinkLogApiParams,
} from "src/types/api";

const api = axios.create({
  baseURL: `${ANALYTICS_LOG_API.domain}/logs`,
});

const request = async ({ path, params }: LogApiRequestParams) =>
  api.post(path, params);

export default {
  visit: async (params: VisitLogApiParams) =>
    request({
      path: "/visit",
      params: {
        consumer_token: params.consumerToken,
        visit_token: params.visitToken,
        video_choose_id: params.videoChooseId,
        viewed_at: params.viewedAt,
      },
    }),
  play: async (params: PlayLogApiParams) =>
    request({
      path: "/play",
      params: {
        consumer_token: params.consumerToken,
        visit_token: params.visitToken,
        video_choose_id: params.videoChooseId,
        video_id: params.videoId,
        viewed_at: params.viewedAt,
      },
    }),
  nextAction: async (params: NextActionLogApiParams) =>
    request({
      path: "/next_action",
      params: {
        consumer_token: params.consumerToken,
        visit_token: params.visitToken,
        video_choose_id: params.videoChooseId,
        video_id: params.videoId,
        next_action_id: params.nextActionId,
        viewed_at: params.viewedAt,
      },
    }),
  copyLink: async (params: CopyLinkLogApiParams) =>
    request({
      path: "/copy_link",
      params: {
        consumer_token: params.consumerToken,
        visit_token: params.visitToken,
        video_choose_id: params.videoChooseId,
        video_id: params.videoId,
        copied_at: params.copiedAt,
      },
    }),
};
